import { useQuery, useMutation } from '@tanstack/react-query';

import Axios from 'axios';
import { queryClient } from 'QueryClientProvider';

import { forceReloadContact } from '@hooks/API/Contact/UseContact';

const useContactBankAccounts = (ID) => {
    const disableQuery = !ID || isNaN(parseInt(ID));
    const intID = !disableQuery ? parseInt(ID) : null;
    return useQuery({
        queryKey: ['contactbankaccounts', intID],
        queryFn: () => Axios.get(`/contacts/bankaccounts/${intID}`),
        staleTime: 30000,
        cacheTime: 30000,
        enabled: !disableQuery,
    });
};

const forceReloadContactBankAccounts = (ID) => {
    const intID = Number(ID);
    queryClient.invalidateQueries({ queryKey: ['contactbankaccounts', intID] });
};

const editContactBankAccount = async ({ data, bankId, contactID }) => Axios.put(`/contactbankaccounts/${bankId}`, data);

const onUpdateContactBankAccounts = (ID) => {
    forceReloadContactBankAccounts(ID);
    forceReloadContact(ID);
};

const useEditContactBankAccount = () => {
    return useMutation({
        mutationFn: editContactBankAccount,
        onSuccess: (data, variables) => {
            onUpdateContactBankAccounts(variables.contactID);
        },
    });
};

const addContactBankAccount = ({ data, contactID }) => Axios.post(`/contactbankaccounts`, data);

const useAddContactBankAccount = () => {
    return useMutation({
        mutationFn: addContactBankAccount,
        onSuccess: (data, variables) => {
            onUpdateContactBankAccounts(variables.contactID);
        },
    });
};

const removeContactBankAccount = async ({ ID, contactID }) => Axios.delete(`/contactbankaccounts/${ID}`);

const useRemoveContactBankAccount = () => {
    return useMutation({
        mutationFn: removeContactBankAccount,
        onSuccess: (data, variables) => {
            onUpdateContactBankAccounts(variables.contactID);
        },
    });
};

export {
    useContactBankAccounts,
    forceReloadContactBankAccounts,
    useAddContactBankAccount,
    useEditContactBankAccount,
    useRemoveContactBankAccount,
};
